import { Component, HostListener, Inject } from '@angular/core';
import { ConfirmDialogConfig } from '../model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'pim-confirm-dialog',
    templateUrl: './confirm.dialog.component.html',
    styleUrls: ['./confirm.dialog.component.sass'],
    standalone: false
})
export class ConfirmDialogComponent {

	feedback: boolean = true;

	constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>,
				@Inject(MAT_DIALOG_DATA) public config: ConfirmDialogConfig) {
	}
	selectFeedback(value: boolean): void {
		this.feedback = value;
	}

	save(): void {
		this.dialogRef.close({
			action: 'save',
			feedback: this.feedback
		});
	}


	@HostListener('document:keyup', ['$event'])
	keyup(event: KeyboardEvent): void {
		switch (event.key) {
			case 'Escape': {
				this.dialogRef.close('false');
				break;
			}
			case 'Enter': {
				this.dialogRef.close('true');
				break;
			}
		}
	}
}
